/**
 * @desc: 支付路由映射
 * @created: 2020/6/2
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'
import qs from 'qs'

// 获取列表数据
export const getListData = params => {
  return request.get('/payment/detail', params)
}

// 查询所有通道
export const getPaymentChannels = params => {
  return request.get('/channel/listPaymentChannel', params)
}

// 根据商户好查询商户信息
export const getPaymentDetails = params => {
  return request.get('/payment/select', params)
}

// 注册单条数据通道
export const sendRegisteredOne = data => {
  return request.post('/payment/registered', qs.stringify(data))
}

// 批量数据注册通道
export const sendRegisteredList = data => {
  return request.post('/payment/pay', data, { json: true })
}
